import { render, staticRenderFns } from "./applyShop.vue?vue&type=template&id=1b7139c6&scoped=true&"
import script from "./applyShop.vue?vue&type=script&lang=js&"
export * from "./applyShop.vue?vue&type=script&lang=js&"
import style0 from "./applyShop.vue?vue&type=style&index=0&id=1b7139c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7139c6",
  null
  
)

export default component.exports